import { NgIf } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { searchIcon, SVGIcon } from "@progress/kendo-svg-icons";

@Component({
  selector: 'query-panel-filter-box',
  standalone: true,
  styleUrls: ['./query-panel-filter-box.component.scss'],
  templateUrl: './query-panel-filter-box.component.html',
  imports: [ButtonsModule, InputsModule, NgIf]
})

export class QueryPanelFilterBoxComponent
  implements OnInit {
  /*-------------------------- Input / Outputs --------------------------------*/

  @Input() placeholder: string = "";
  @Input() showSearchButton: boolean = false;

  @Output() onFilterChange = new EventEmitter<string>();

  /*-------------------------- Internal properties  ------------------*/

  protected filterValue: string = "";
  protected isFilterFocus: boolean = false;
  protected searchSvg: SVGIcon = searchIcon;

  /*-------------------------- Constructor  --------------------------*/
  constructor () {}

  /*-------------------------- ng --------------------------*/
  ngOnInit(): void {
  }

  /*-------------------------- Event handlers --------------------------*/

  onButtonClick() {
    this.onFilterChange.emit(this.filterValue);
  }

  onFilterTextChange(value: string) {
    this.filterValue = value;
  }

  onFilterInputBlur() {
    this.isFilterFocus = false;
  }

  onFilterInputFocus() {
    this.isFilterFocus = true;
  }

  /*-------------------------- Host listeners --------------------------*/

  // Keyboard event: handles the "press enter to search" because Telerik
  // doesn't give us a keypress event for the kendoTextBox.
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.isFilterFocus && event.key == "Enter") {
      this.onFilterChange.emit(this.filterValue);
    }
  }
}
